import { useEffect, useSyncExternalStore } from 'react';

/**
 * AI Agent 오브를 <b>잠깐 다른 자리에 세우는</b> 신호 (사용자 지시 2026-11-02).
 *
 * <p>「작성 안내가 필요하신가요?」 처럼 화면이 사람에게 묻는 창이 뜨면, 오브가 그 창의 좌상단으로
 * 날아가 붙어 <b>오브가 묻는 것처럼</b> 보이게 한다. 창이 닫히면 원래 자리로 돌아간다.
 *
 * <p>값은 붙을 요소의 {@code data-orb-anchor} 이름이다. 회사 자리·개인 자리(저장된 값)는 건드리지
 * 않는다 — 이 신호가 비면 오브는 늘 그 자리로 돌아간다. 한 번에 하나만 선다: 나중에 부른 쪽이 이긴다.
 */

let anchor: string | null = null;
const listeners = new Set<() => void>();

function setOrbAnchor(next: string | null): void {
  if (next === anchor) return;
  anchor = next;
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** 오브가 지금 붙어야 할 요소 이름. 없으면 null — 제자리다. */
export function useOrbAnchor(): string | null {
  return useSyncExternalStore(subscribe, () => anchor, () => null);
}

/**
 * 이 컴포넌트가 떠 있는 동안 오브를 {@code name} 요소 옆에 세운다. 언마운트되면 제자리로 돌린다.
 * 요소에는 {@code data-orb-anchor={name}} 을 단다.
 */
export function useAnchorOrb(name: string, active = true): void {
  useEffect(() => {
    if (!active) return;
    setOrbAnchor(name);
    return () => {
      if (anchor === name) setOrbAnchor(null);
    };
  }, [name, active]);
}
